"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var Message = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.loading.color;
});
var LoadingMessage = function () {
    var getTranslation = use_translations_hook_1.default().getTranslation;
    return react_1.default.createElement(Message, { "data-test-id": "loading-message" },
        getTranslation('GLOBAL:LOADING'),
        "...");
};
LoadingMessage.displayName = 'LoadingMessage';
exports.default = LoadingMessage;
var templateObject_1;
//# sourceMappingURL=loading.component.js.map